import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { networkLogos } from 'src/constants/networkLogos'
import { sportIds } from 'src/constants/personalizationIds'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video="https://assets.fubo.tv/marketing/lp/videos/compressed/Wimbledon24_LP_7s.mp4"
    staticAnnotation={networkLogos.espn}
    title="Watch Wimbledon"
    subtitle="See the superstars of tennis compete live"
    networkSet="sports"
    ctaText={'Start Watching'}
    sportId={sportIds.Tennis}
  />
)
